<template>
  <div class="ms-form ms-form--narrow">
    <q-form @submit="this.onSubmit">
      <p v-if="this.statusesLoading" class="ms-empty">Загрузка статусов…</p>
      <p v-else-if="this.error" class="ms-empty multiple-status__error">{{ this.error }}</p>
      <div v-else class="ms-form-grid ms-form-grid--single">
        <CustomSelect
          :options="this.statuses"
          label="Статус"
          :required="true"
          optionValueKey="provider_request_status_id"
          optionLabelKey="provider_request_status_name"
          :value="this.provider_request_status_id || ''"
          @change="(value) => (this.provider_request_status_id = value)"
        />
        <p class="multiple-status__hint">
          Статус будет изменён на всех позициях выбранных заявок ({{ this.providerRequestIds.length }}).
        </p>
      </div>

      <CustomModalFooter
        :btn-loading="this.loading"
        :hideSubmitBtn="this.statusesLoading || !!this.error"
      />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomSelect from "@/components/form/CustomSelect";
import { getMultipleStatuses } from "@/views/ProviderRequests/services";

export default {
  name: "provider-requests-multiple-status",
  components: { CustomModalFooter, CustomSelect },
  props: ["data"],
  data() {
    return {
      loading: false,
      statusesLoading: true,
      error: "",
      statuses: [],
      provider_request_status_id: "",
    };
  },
  computed: {
    providerRequestIds() {
      return this.data?.body?.provider_request_id_arr || [];
    },
  },
  async created() {
    const res = await getMultipleStatuses(this.providerRequestIds);
    this.statusesLoading = false;
    if (res.error) {
      this.error = res.error;
      return;
    }
    this.statuses = res.data;
    if (!this.statuses.length) this.error = "Нет общих статусов для выбранных заявок";
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      await this.data?.onSubmit({
        provider_request_id_arr: this.providerRequestIds,
        provider_request_status_id: this.provider_request_status_id,
      });
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.multiple-status__hint {
  margin: 0;
  font-size: 12px;
  color: var(--ms-muted);
}

.multiple-status__error {
  color: var(--ms-danger);
}
</style>
